import { Dispatch } from 'redux';
import { api } from '../config/axiosConfig';
import { settingsConstants } from '../constants';
import { FetchUserResponse } from '../types';
import { AxiosResponse } from 'axios';
import axios from 'axios';

export interface SettingsProfileFormErrors {
    firstName?: string;
    lastName?: string;
    weight?: string;
}

export const cancelEditProfile = () => {
    return {
        type: settingsConstants.CANCEL_EDIT_PROFILE
    };
};

export const updateErrorsProfile = (errors: SettingsProfileFormErrors) => {
    return {
        type: settingsConstants.UPDATE_ERRORS_PROFILE,
        data: errors
    };
};

export const fetchUserRequest = (id: number) => {
    const requestURL = `/v1/athletes/${id}`;
    return api().get(requestURL);
};

export const fetchUser = (id: number) => {
    const request = () => (
        { type: settingsConstants.FETCH_USER_REQUEST }
    );

    const success = (user: FetchUserResponse) => (
        { type: settingsConstants.FETCH_USER_SUCCESS, user }
    );

    const failure = (error: string) => (
        { type: settingsConstants.FETCH_USER_FAILURE, error }
    );

    return (dispatch: any) => {
        return fetchUserRequest(id)
            .then((response: any) => {
                dispatch(success(response.data));
                return response.data;
            })
            .catch((error: any) => {
                dispatch(failure(error.response?.data?.message || 'Failed to fetch user'));
            });
    };
};

export const fetchUserProfile = (id: number) => {
    const request = () => (
        { type: settingsConstants.FETCH_USER_REQUEST }
    );

    const success = (user: FetchUserResponse) => (
        { type: settingsConstants.FETCH_USER_SUCCESS, user }
    );

    const failure = (error: string) => (
        { type: settingsConstants.FETCH_USER_FAILURE, error }
    );

    return (dispatch: any) => {
        dispatch(request());
        return api().get(`/v1/athletes/${id}`)
            .then((response: any) => {
                dispatch(success(response.data));
                return response.data;
            })
            .catch((error: any) => {
                dispatch(failure(error.response?.data?.message || 'Failed to fetch user profile'));
            });
    };
};

// First: Get the AWS S3 uploadUrl and imageUrl from the backend
// Second: Upload to AWS S3, imageUrl will then be a valid url
export const uploadImage = (image: File) => {
    const success = (imageUrl: string) => {
        return {
            type: settingsConstants.IMAGE_UPLOAD_SUCCESS,
            imageUrl: imageUrl
        };
    };

    const failure = (errors: any) => {
        return {
            type: settingsConstants.IMAGE_UPLOAD_FAILURE,
            errors: errors
        };
    };

    const signingURL = `/v1/athlete/sign-s3?fileName=${image.name}&fileType=${image.type}`;

    return (dispatch: any) => {
        api()
            .get(signingURL)
            .then((response: any) => {
                axios
                    .put(response.data.uploadUrl, image)
                    .then(() => { dispatch(success(response.data.imageUrl)); })
                    .catch((error) => { dispatch(failure(error)); });
            })
            .catch((error) => { dispatch(failure(error)); });
    };
};

export const modifyDisplaySettings = (displaySettings: any) => {
    const request = () => (
        { type: settingsConstants.MODIFY_DISPLAY_SETTINGS_REQUEST }
    );

    const success = (data: any) => (
        { type: settingsConstants.MODIFY_DISPLAY_SETTINGS_SUCCESS, data }
    );

    const failure = (error: string) => (
        { type: settingsConstants.MODIFY_DISPLAY_SETTINGS_FAILURE, error }
    );

    const requestURL = `/v1/athlete/display-settings`;

    return (dispatch: any) => {
        dispatch(request());
        return api().patch(requestURL, displaySettings)
            .then((response: any) => {
                dispatch(success(response.data));
                return response;
            })
            .catch((error: any) => {
                dispatch(failure(error.response?.data?.message || 'Failed to modify display settings'));
                return error;
            });
    };
};

export const modifyPrivacySettings = (privacySettings: any) => {
    const request = () => (
        { type: settingsConstants.MODIFY_PRIVACY_SETTINGS_REQUEST }
    );

    const success = (data: any) => (
        { type: settingsConstants.MODIFY_PRIVACY_SETTINGS_SUCCESS, data }
    );

    const failure = (error: string) => (
        { type: settingsConstants.MODIFY_PRIVACY_SETTINGS_FAILURE, error }
    );

    const requestURL = `/v1/athlete/privacy-settings`;

    return (dispatch: any) => {
        dispatch(request());
        return api().patch(requestURL, privacySettings)
            .then((response: any) => {
                dispatch(success(response.data));
                return response;
            })
            .catch((error: any) => {
                dispatch(failure(error.response?.data?.message || 'Failed to modify privacy settings'));
                return error;
            });
    };
};